import { handleActions } from 'redux-actions'
import { fromJS, Map } from 'immutable'

import * as CustomTagActions from 'actions/custom_tags'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  show: false,
  selectedNewsId: 0,
  suggestedCustomTagIds: [],
  suggestedCustomTagMatches: {},
  suggestionsLoading: false
})

export default handleActions({
  [CustomTagActions.showAssignCustomTagsToNewsDialog]: (state, { payload: newsId }) => state.merge(fromJS({
    show: true,
    selectedNewsId: newsId,
    suggestedCustomTagIds: [],
    suggestedCustomTagMatches: {},
    suggestionsLoading: true
  })),
  [CustomTagActions.loadCustomTagSuggestionsStart]: state => state.merge(fromJS({
    suggestionsLoading: true,
    suggestedCustomTagIds: [],
    suggestedCustomTagMatches: {}
  })),
  [CustomTagActions.loadCustomTagSuggestionsSuccess]: (state, { payload }) => {
    const suggestions = fromJS(payload || [])

    return state.merge({
      suggestionsLoading: false,
      suggestedCustomTagIds: suggestions.map(suggestion => suggestion.get('id')).toList(),
      suggestedCustomTagMatches: suggestions.reduce(
        (matches, suggestion) => matches.set(String(suggestion.get('id')), fromJS({
          match: suggestion.get('match'),
          matchCount: suggestion.get('matchCount') || 0,
          matchCountCapped: Boolean(suggestion.get('matchCountCapped')),
          fragments: suggestion.get('fragments') || fromJS([])
        })),
        (state.get('suggestedCustomTagMatches') || Map()).clear()
      )
    })
  },
  [CustomTagActions.loadCustomTagSuggestionsError]: state => state.merge(fromJS({
    suggestionsLoading: false,
    suggestedCustomTagIds: [],
    suggestedCustomTagMatches: {}
  })),
  [CustomTagActions.hideAssignCustomTagsToNewsDialog]: () => initialState,

  [AppActions.resetState]: () => initialState
}, initialState)
